var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.FormControlTypeRelationshipManyToMany, {
        ref: "myChild",
        attrs: {
          "current-data": _vm.currentData,
          field: _vm.field,
          "form-id": _vm.formId,
        },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "mt-2" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: { disabled: _setup.btnDisabled },
            on: { click: _setup.sendEmail },
          },
          [_vm._v("\n            Send email\n        ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }